import { AppRuleActions, AppRuleNames } from "@Front/Api/Entities/rule";
import MenuItem from "@Front/Components/DesignSystem/Menu/MenuItem";
import Rules, { RulesMode } from "@Front/Components/Elements/Rules";
import { Routes } from "@Front/Config/Routes";
import { notaryFolderNavArchivedLabel, notaryFolderNavCurrentLabel } from "@Front/Utils/applyFolderAsOperationFr";

export function FoldersMenuSection(): React.ReactElement {
	return (
		<Rules
			mode={RulesMode.OPTIONAL}
			rules={[
				{
					action: "read" as AppRuleActions,
					name: AppRuleNames.officeFolders,
				},
			]}>
			<>
				<MenuItem
					item={{
						text: notaryFolderNavCurrentLabel(),
						routesActive: [Routes.pages.Folder.FolderInformation, Routes.pages.Folder.CreateFolder],
						link: Routes.pages.Folder.base,
					}}
				/>

				<MenuItem
					item={{
						text: notaryFolderNavArchivedLabel(),
						routesActive: [Routes.pages.Folder.FolderArchived.base],
						link: Routes.pages.Folder.FolderArchived.base,
						hasSeparator: true,
					}}
				/>
			</>
		</Rules>
	);
}
